// Numbers shared by the Worker (src/data-export.ts) and the web app, kept in a file with no imports.
export const EXPORT_WINDOW_DAYS = 7;
export const EXPORT_MAX_DOWNLOADS = 5;
/** What the page and emails promise: the real delay is 24 hours, but a failed mail retries for up to 72 more. */
export const EXPORT_PUBLIC_DELAY_HOURS = "24～96";
